export default __webpack_public_path__ + "static/media/smart-goals.11433d92.svg";